import * as React from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'

interface props {
  state: boolean
  handleClose: () => void
  handleSubmit: () => void | Promise<void>
  title?: string
  text: string
  continueText?: string
  cancelText?: string
}

export default function ConfirmModal({
  state,
  handleClose,
  handleSubmit,
  title,
  text,
  continueText = 'Ja',
  cancelText = 'Avbryt',
}: props) {
  return (
    <Box>
      <Modal
        open={state}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            maxWidth: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 5,
          }}
        >
          <Box>
            {title && (
              <Typography
                variant="h5"
                fontWeight={500}
                mb={2}
                textAlign="center"
              >
                {title}
              </Typography>
            )}
            <Typography sx={{ textAlign: 'center' }} component="p">
              {text}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mt: 4,
                gap: 2,
              }}
            >
              <Button
                onClick={() => {
                  handleClose()
                  Promise.resolve(handleSubmit()).catch((error) => {
                    // Keep modal interactions resilient even if async handlers fail.
                    console.error('ConfirmModal submit failed', error)
                  })
                }}
                variant="contained"
                sx={{ color: (t) => t.palette.common.white }}
              >
                {continueText}
              </Button>
              <Button onClick={handleClose}>{cancelText}</Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  )
}
